<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Change Password
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="goBack"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="ac-input-container">
        <div class="ac-input-header">
          New Password
        </div>
        <SACInput
          field="password"
          placeholder="New Password"
          :value="password"
          :change="handleChange"
          :error="error.passwordErr"
        />
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Confirm Password
        </div>
        <SACInput
          field="confirmPassword"
          placeholder="Confirm Password"
          :value="confirmPassword"
          :change="handleChange"
          :error="error.confirmPasswordErr"
        />
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="ac-form-button"
        @click="goBack"
      >
        Cancel
      </button>
      <button
        type="button"
        class="ac-form-button"
        @click="updatePassword"
      >
        Save
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
      text="Updating"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import settingMixin from '@shared/mixins/settingMixin';

import SACInput from '@shared/components/sac/SACInput.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'ChangePassword',
  components: {
    SACInput,
    ProcessOverlay,
  },
  mixins: [settingMixin],
  data() {
    return {
      password: '',
      confirmPassword: '',
      processing: false,
      error: {},
    };
  },
  methods: {
    goBack() {
      if (this.currentUser.id) {
        this.toggleActionModal(true, 'edit-user');
      } else {
        this.toggleActionModal(true, 'edit-technician');
      }
    },
    handleChange(field, value) {
      this[field] = value;
    },
    async updatePassword() {
      const {
        password,
        confirmPassword,
      } = this;
      const error = {};
      if (!password) {
        error.passwordErr = 'Password is required.';
      }
      if (!confirmPassword) {
        error.confirmPasswordErr = 'Confirm password is required.';
      } else if (password !== confirmPassword) {
        error.confirmPasswordErr = 'Confirm password does not match password.';
      }
      this.error = error;
      if (Object.keys(error).length === 0) {
        this.processing = true;
        await this.$store.dispatch('changeUserPassword', {
          password,
        });
        this.processing = false;
        this.goBack();
      }
    },
  },
};
</script>

<style lang="scss"></style>
